import { styled, theme } from "@theme/stitches.config"
import { Label as BaseLabel } from "../styles"

export const Wrapper = styled("div", {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@mdDown": {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    "& a": {

    }
})

export const StyledDiv = styled("div", {
    marginLeft: 2,
    "& a": {

    }
})

export const Label = styled(BaseLabel, {
    marginBottom: "8px !important",
    color: "white",
    marginTop: 10,
    "@mdDown": {
        margin: "10px 0 5px 0"
    }
})

export const StyledSpan = styled("span", {

})

export const TextAreaField = styled("textarea", {
    minHeight: 100,
    maxHeight: 300,
    color: "white",
    resize: "vertical",
    border: "1px solid",
    borderColor: theme.colors.R500,
    marginTop: 0,
    marginBottom: 0,
    lineHeight: 1.25,
    padding: 10,
    width: "100%",
    borderRadius: 4,
    background: theme.colors.N900,
    boxSizing: "border-box",
    "&:focus": {
        outline: "none",
        boxShadow: "none"
    },
    "@mdDown": {
        maxWidth: "100%",
        flex: "0 0 100%",
        width: "100%"
    }
})

export const HelperText = styled("p", {
    marginTop: 10,
    display: "flex",
    marginBottom: 0,
    fontSize: 12,
    fontWeight: theme.fontWeights.medium,
    lineHeight: 1.2,
    "@mdDown": {
        maxWidth: "100%",
        flex: "0 0 100%"
    }
})
